import { __rest, __assign } from 'tslib';
import React__default, { Suspense, useEffect } from 'react';
import { useDataView, useKeyboardSelection, fetcherModeAtom, dataviewElementFetcherSelector, QueryParamElement } from '@keepeek/commons';
import { Box, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useReactTable, getCoreRowModel, flexRender } from '@tanstack/react-table';
import clsx from 'clsx';
import { useRecoilValue } from 'recoil';
import { withSuspense } from '../../../withSuspense/index.js';
import StyledListDataView, { classes, PREFIX } from './index.styled.js';
import { ListDataViewLoading } from './ListDataViewLoading.js';
import ListDataViewRow from './ListDataViewRow/index.js';

/**
 * Wrap dataview in suspense component because loading component need props
 */
var ListDataViewWithSuspense = function (_a) {
    var dataViewKey = _a.dataViewKey, className = _a.className, props = __rest(_a, ["dataViewKey", "className"]);
    return (React__default.createElement(Box, { className: clsx("ListDataView", className) },
        React__default.createElement(Suspense, { fallback: React__default.createElement(ListDataViewLoading, { dataViewKey: dataViewKey }) },
            React__default.createElement(ListDataView, __assign({ dataViewKey: dataViewKey }, props)))));
};
var ListDataView = function ListDataview(_a) {
    var KIcon = _a.KIcon, goToPageWithBackContext = _a.goToPageWithBackContext, sentryCallback = _a.sentryCallback, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, enabledActions = _a.enabledActions, dataViewKey = _a.dataViewKey, filters = _a.filters, _b = _a.showHeaders, showHeaders = _b === void 0 ? true : _b, columns = _a.columns, allowSelection = _a.allowSelection, allowNavigation = _a.allowNavigation, onDataViewFirstRender = _a.onDataViewFirstRender, onElementDoubleClick = _a.onElementDoubleClick, onElementActionClick = _a.onElementActionClick, actionButtonsColor = _a.actionButtonsColor, attachmentsVisible = _a.attachmentsVisible, title = _a.title, summary = _a.summary;
    var elements = useDataView({ key: dataViewKey, filters: filters || null }).elements;
    useKeyboardSelection(dataViewKey, elements, allowSelection);
    var table = useReactTable({
        columns: columns,
        data: elements,
        getCoreRowModel: getCoreRowModel(),
        enableRowSelection: true,
        enableMultiRowSelection: true
    });
    var mode = useRecoilValue(fetcherModeAtom);
    var getElementBackContext = useRecoilValue(dataviewElementFetcherSelector(mode)).getElementBackContext;
    useEffect(function () {
        onDataViewFirstRender && onDataViewFirstRender();
    }, [onDataViewFirstRender]);
    return (React__default.createElement(StyledListDataView, null,
        React__default.createElement(Table, { size: "medium", className: classes.listDataView, title: title, summary: summary },
            showHeaders && (React__default.createElement(TableHead, { className: classes.headersRow }, table.getHeaderGroups().map(function (headerGroup) { return (React__default.createElement(TableRow, { sx: { backgroundColor: function (theme) { return theme.palette.divider; } }, key: headerGroup.id }, headerGroup.headers.map(function (header) { return (React__default.createElement(TableCell, { className: clsx(classes.header, "".concat(PREFIX, "-").concat(header.column.id, "Header")), key: header.id }, header.isPlaceholder
                ? null
                : flexRender(header.column.columnDef.header, header.getContext()))); }))); }))),
            React__default.createElement(TableBody, { className: classes.body }, table.getRowModel().rows.map(function (row) {
                return (React__default.createElement(ListDataViewRow, { key: row.id, dataViewKey: dataViewKey, filters: filters, KIcon: KIcon, row: row, sentryCallback: sentryCallback, shareTokenDownloadAuthorized: shareTokenDownloadAuthorized, openElementCallback: function (_a) {
                        var elementId = _a.elementId, options = _a.options;
                        if (options === null || options === void 0 ? void 0 : options.highlightAssociations) {
                            goToPageWithBackContext({
                                sourcePage: { pathname: "/search" },
                                targetPage: {
                                    pathname: "/element",
                                    query: { id: elementId, mode: QueryParamElement.HIGHLIGHT_ASSOCIATIONS }
                                }
                            });
                        }
                        else {
                            goToPageWithBackContext(getElementBackContext(elementId));
                        }
                    }, enabledActions: enabledActions, allowNavigation: allowNavigation, onDoubleClick: function () { return onElementDoubleClick(row.original.id); }, onActionClick: function (action) {
                        return onElementActionClick ? onElementActionClick(row.original.id, action) : null;
                    }, actionButtonsColor: actionButtonsColor, attachmentsVisible: attachmentsVisible }));
            })))));
};
var ListDataView$1 = withSuspense(ListDataViewWithSuspense);

export { ListDataView$1 as default };
//# sourceMappingURL=index.js.map
